<template>
  <div class="box_rank your_prizes">
    <h3>{{ $_translations.value.page_leaderboard_section_prizes_title }}</h3>

    <div class="prizes_swiper_cont">
      <slot></slot>
    </div>
  </div>
</template>

<script setup></script>
